import {
	getPropertySortText,
	OptionsMenu,
	OptionsMenuItem,
	SearchInputForm,
	SearchPlaceholder
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import styles from "./SearchAndSort.module.less";
import { SearchSortKind } from "client/Api/SearchSettings/searchSettings";

export type SearchAndSortProps = {
	sortKind: SearchSortKind;
	searchTerm: VersionedValue<string>;
	onSearch: (term: VersionedValue<string>) => void;
	onSortKindChange: (kind: SearchSortKind) => void;
};

export const SearchAndSort = (props: SearchAndSortProps): ReactElement => {
	const {
		sortKind,
		searchTerm,
		onSearch,
		onSortKindChange
	} = props;

	return (
		<div className={styles.searchAndSort}>
			<SearchInputForm
				value={searchTerm}
				onChange={(value, version) => onSearch({ value, version})}
				height="large"
				icon="filter"
				placeholder={(
					<SearchPlaceholder
						kind="filter"
						properties={[localize("_Name")]}
					/>
				)}
				trackingId="search"
			/>

			<OptionsMenu
				value={sortKind}
				onChange={onSortKindChange}
				trackingId="sortKind"
				options={sortOptions}
				title={localize("_SortBy")}
				buttonSize="large"
				icon="arrow-up-arrow-down"
			/>
		</div>
	);
};
SearchAndSort.displayName = "SearchAndSort";

export const sortKindToNameMap: Record<SearchSortKind, string> = {
	[SearchSortKind.AlphabeticalAscending]: getPropertySortText("_Name", "_AToZ"),
	[SearchSortKind.AlphabeticalDescending]: getPropertySortText("_Name", "_ZToA"),
	[SearchSortKind.Custom]: localize("_CustomSorting"),
};

const sortOptions: readonly OptionsMenuItem<SearchSortKind>[] = [
	{
		text: sortKindToNameMap[SearchSortKind.AlphabeticalAscending],
		value: SearchSortKind.AlphabeticalAscending
	},
	{
		text: sortKindToNameMap[SearchSortKind.AlphabeticalDescending],
		value: SearchSortKind.AlphabeticalDescending
	},
	{
		text: sortKindToNameMap[SearchSortKind.Custom],
		value: SearchSortKind.Custom
	}
];
